var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"d-flex flex-row align-center"},[_c('v-img',{attrs:{"src":_vm.iconForType,"max-width":_vm.width,"eager":_vm.eager}}),(_vm.showLabel)?_c('span',{class:_vm.labelClass},[_vm._v(_vm._s(_vm.label))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }